import { addAugmentationSetWorkflow } from './addAugmentationSet';
import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { editAugmentationSetWorkflow } from './editAugmentationStep';

export const workflows: WorkflowOptions[] = [
  addAugmentationSetWorkflow,
  editAugmentationSetWorkflow,
  ...Object.values(generateAssetStatusWorkflow('augmentationSet')),
];

export default workflows;
